import actions from './actions';
import mutations from './mutations';
import getters from './getters';

export default {
    state() {
        return {
            approvalData: null,
        };
    },
    mutations,
    actions,
    getters,
};
